'use strict';

/*global initialize*/
jQuery('document').ready(function () {
    $('body').on('click', '.file-container__add', function () {
        var $fileContainer = $(this).closest('.form-group').find('.file-container:last');
        var $clone = $fileContainer.clone();
        $clone.insertAfter($fileContainer);
        $clone.find('.file--init').removeClass('file--init');

        initialize($clone);
        $clone.find('.file__btn-remove').click();

        return false;
    });
});
